import { useRoutes } from "react-router-dom"
import { ThemeProvider, createTheme } from "@mui/material/styles"
// import Layout from "./layout"
import { useEffect } from "react";
import routes from "./routes/index";
import { AliveScope } from 'react-activation';

const theme = createTheme({
    palette: {
        primary: {
            // main: "#FF7E07",
            main: "#000000",
            mainsat: "#FF7E07",
            green: "#279F5B",
            darkwhite: '#F5F5F5'
        },
        mgreen: {
            main: '#279F5B',
            light: '#2fc06e',
            dark: '#207f49',
            contrastText: 'white',
        },
        mwhite: {
            main: '#EEEEEE',
            light: '#FFFFFF',
            dark: '#DDDDDD',
            contrastText: 'black',
        },
        mblack: {
            main: '#111111',
            light: '#333333',
            dark: '#000000',
            contrastText: 'white',
        }
    },
    // typography: {
    //     fontSize: 16, // 设置默认的字体大小为 16px
    //     // 你还可以在这里设置其他的字体属性，比如字体系列（fontFamily）、字重（fontWeight）等
    // },
    overrides: {
        MuiInput: {
            input: {
                "&::placeholder": {
                    color: "red"
                },
                color: "white", // if you also want to change the color of the input, this is the prop you'd use
            }
        },

    },
    // components:{
    //     MuiListItemButton: {
    //         styleOverrides: {
    //             root: {
    //                 '&.Mui-selected': {
    //                     backgroundColor: '#ff0000',
    //                 }
    //             }
    //         },
    //     },
    // },

    transitions: {
        create: () => 'all 0.3s ease', // 配置过渡效果
    },
})



function App() {

    const content = useRoutes(routes);
    return (
        // <ThemeProvider theme={theme}>
        //     <Router>
        //         <Routes>
        //             <Route exact path="/" element={<Layout></Layout>}></Route>
        //         </Routes>
        //     </Router>
        // </ThemeProvider>
        <AliveScope>
            <ThemeProvider theme={theme}>
                {/* <PageViewTracker />
            <ScreenProvider>{content}</ScreenProvider>
            <Toaster /> */}
                {content}
            </ThemeProvider>
        </AliveScope>
    )
}

export default App
